import angular from 'angular';
import SupportForYourPracticeService from './supportforyourpractice.service';
'use strict';
var SupportforyourpracticeComponent = /** @class */ (function () {
    /*@ngInject*/
    function SupportforyourpracticeComponent(SupportForYourPracticeService) {
        var _this = this;
        this.video = false;
        var sfyp = SupportForYourPracticeService;
        sfyp.getEducation()
            .then(function (response) {
            _this.education = response.data.response;
        });
        sfyp.getWellevate()
            .then(function (response) {
            _this.wellevate = response.data.response;
        });
        sfyp.getQuality()
            .then(function (response) {
            _this.quality = response.data.response;
        });
    }
    SupportforyourpracticeComponent.prototype.playVideo = function ($event) {
        this.video = true;
    };
    return SupportforyourpracticeComponent;
}());
export { SupportforyourpracticeComponent };
SupportforyourpracticeComponent.$inject = ['SupportForYourPracticeService'];
export default angular.module('directives.supportforyourpractice', [])
    .service("SupportForYourPracticeService", SupportForYourPracticeService)
    .component('supportforyourpractice', {
    template: require('./supportforyourpractice.html'),
    controller: SupportforyourpracticeComponent
})
    .name;
//# sourceMappingURL=supportforyourpractice.component.js.map